import { render } from "./TheFooter.vue?vue&type=template&id=4ea2ca7c"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=4ea2ca7c&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__